export default __webpack_public_path__ + "static/media/slider2.374e5623.jpg";